import React, { useRef, useState } from 'react'
import { useFieldArray } from 'react-hook-form'
import { Button } from 'primereact/button'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Toast } from 'primereact/toast'
import { confirmDialog } from 'primereact/confirmdialog'
import ControllerInput from 'base/ControllerInput'

export default function ListaMunicipioItem({ form, service }) {
    const { control } = form
    const { fields, append, remove } = useFieldArray({
        control,
        name: 'lista_municipio_item'
    })

    const [municipios, setMunicipios] = useState([])
    const toast = useRef(null)
    const municipioSelecionado = form.watch('municipio_busca')

    const municipioSearch = (event) => {
        const query = (event?.query || '').trim()
        if (!query) {
            setMunicipios([])
            return
        }

        service.filterMunicipio({ municipio: query })
            .then(response => {
                const options = response.data.data.map(item =>
                    service.formatMunicipioOption(item.codigo_muni, item.descricao_muni, item.sigla_uf || item?.meta?.sigla_uf)
                )
                setMunicipios(options)
            }).catch(() => setMunicipios([]))
    }

    const adicionar = (e) => {
        e.preventDefault()

        if (!municipioSelecionado || !municipioSelecionado?.codigo_muni) {
            toast.current?.show({ severity: 'warn', summary: 'Atenção', detail: 'Selecione um município para adicionar.', life: 4000 })
            return
        }

        const jaExiste = fields.some(item => {
            const codigo = item?.municipio?.codigo_muni || item?.cod_muni_muli
            return codigo === municipioSelecionado.codigo_muni
        })

        if (jaExiste) {
            toast.current?.show({ severity: 'warn', summary: 'Atenção', detail: 'Município já adicionado.', life: 4000 })
            return
        }

        append(service.getNewListaMunicipioItem({
            cod_muni_muli: municipioSelecionado.codigo_muni,
            municipio: municipioSelecionado
        }))

        form.setValue('municipio_busca', null, { shouldDirty: false })
    }

    const getIndexById = (row) =>
        fields.findIndex((item) => item.id === row.id)

    const descricaoMunicipio = (row) =>
        row?.municipio?.descricao_munuf || ''

    return (
        <>
            <Toast ref={toast} />
            <div className="md:col-6 lg:col-6 xl:col-6 col-12 pt-0 pl-2 pb-3">
                <label className="text-sm">Adicionar município</label>
                <div className="flex align-items-start gap-2 pt-1 w-full">
                    <ControllerInput
                        id='typeMunicipio'
                        className="flex-1"
                        field="municipio_busca"
                        form={form}
                        service={service}
                        type="autocomplete"
                        label=""
                        suggestions={municipios}
                        completeMethod={municipioSearch}
                        fieldShow='descricao_munuf'
                        placeholder="Digite para buscar"
                    />
                    <Button
                        id='addMunicipio'
                        icon="pi pi-plus"
                        severity="success"
                        size="small"
                        onClick={adicionar}
                    />
                </div>
            </div>

            <div className="col-12">
                <DataTable
                    value={fields}
                    dataKey="id"
                    className="text-sm"
                    size="small"
                >
                    <Column
                        header="Municípios"
                        body={(row) => descricaoMunicipio(row)}
                    />
                    <Column
                        header=""
                        body={(row) => {
                            const index = getIndexById(row)
                            return (
                                <Button
                                    id='remMunicipio'
                                    icon="pi pi-trash"
                                    text
                                    severity="danger"
                                    size="small"
                                    onClick={(event) => {
                                        event.preventDefault()
                                        const atual = fields[index]
                                        confirmDialog({
                                            message: `Confirma remover? ${descricaoMunicipio(atual)}`,
                                            icon: 'pi pi-question-circle',
                                            accept: () => {
                                                const removeds = form.getValues('listaMunicipioItemRemoved') || []
                                                if (atual?.codigo_muli) {
                                                    removeds.push({ codigo_muli: atual.codigo_muli })
                                                    form.setValue('listaMunicipioItemRemoved', removeds)
                                                }
                                                remove(index)
                                            }
                                        })
                                    }}
                                />
                            )
                        }}
                    />
                </DataTable>
            </div>
        </>
    )
}
